export enum CreditType {
    Credit = 1,
    Debit
}